import { Component, EventEmitter, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/modules/confirm-dialog/confirm-dialog.component'
import { faro } from '@grafana/faro-web-sdk'
import { ConsentimentoLgpdService } from 'src/app/services/consentimento-lgpd.service'

const LGPD_NOTICE_VERSION = '1.0'
const LGPD_NOTICE_TEXT =
  'Este relatório contém dados pessoais e/ou sensíveis protegidos pela Lei Geral de Proteção de Dados.<br><br>' +
  'O uso destes dados é restrito à finalidade: <strong>Gestão de Concursos e Inscrições para UNICAMP</strong>.<br><br>' +
  'É vedado o compartilhamento, reprodução ou uso para finalidades diversas.<br><br>' +
  'O tratamento inadequado sujeita o responsável às sanções dos Arts. 52 a 54 da LGPD.<br><br>' +
  'Controlador: <strong>UNICAMP</strong>'

async function sha256Hex(text: string): Promise<string> {
  const data = new TextEncoder().encode(text)
  const hash = await crypto.subtle.digest('SHA-256', data)
  return Array.from(new Uint8Array(hash)).map(b => b.toString(16).padStart(2, '0')).join('')
}

@Component({
  selector: 'app-export-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatDialogModule],
  template: `
    <button mat-raised-button color="primary" (click)="onExport()">
      <mat-icon>save_alt</mat-icon>
      Exportar
    </button>
  `,
})
export class ExportButtonComponent {
  @Output() export = new EventEmitter<void>()

  constructor(
    private dialog: MatDialog,
    private consentimentoService: ConsentimentoLgpdService
  ) {}

  onExport(): void {
    const dialogData = new ConfirmDialogModel('⚠️ AVISO LGPD — Lei 13.709/2018', LGPD_NOTICE_TEXT, 'Estou ciente', 'Cancelar')
    this.dialog
      .open(ConfirmDialogComponent, {
        maxWidth: '700px',
        width: '700px',
        panelClass: 'lgpd-dialog',
        data: dialogData,
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          sha256Hex(LGPD_NOTICE_TEXT).then(hashTermo => {
            faro?.api?.pushEvent('lgpd_consent_accepted', {
              tipo: 'EXPORTACAO_DADOS_PESSOAIS',
              versaoTermo: LGPD_NOTICE_VERSION,
              hashTermo,
              timestamp: new Date().toISOString(),
            })

            this.consentimentoService
              .registrar({
                tipoConsentimento: 'EXPORTACAO_DADOS_PESSOAIS',
                versaoTermo: LGPD_NOTICE_VERSION,
                hashTermo,
                sistemaOrigem: 'inscricao-privado',
                detalhes: JSON.stringify({ url: window.location.pathname }),
              })
              .subscribe({ next: () => this.export.emit() })
          })
        }
      })
  }
}
